module.exports = __webpack_public_path__ + "img/arrow-down.1a8e88ec.svg";